import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILogo } from 'src/app/layout/configuration/configuration.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LogoService {
  private baseUrl = environment.baseUrl + environment.baseApi;

  constructor(
    private readonly http: HttpClient,
  ) {}

  public async getLogo(params?: string) {
    const headers = null
    const request = new HttpRequest<any>('GET', this.baseUrl + 'logo', null, {
      reportProgress: true,
      headers: headers,
      params: params ? new HttpParams().set('type', params) : new HttpParams(),
    });

    let response: ILogo;
    await this.http
      .request(request)
      .toPromise()
      .then((res) => {
        if (res instanceof HttpResponse) response = res.body as ILogo;
      })
      .catch((e) => console.log(e));

      return response
  }
}

